import * as angular from "angular";
import * as _ from "lodash";

export class ConfigurationCommons {
  constructor() {
  }

  getPreferencesByTab(preferences) {
    let tabs = [];

    _.forOwn(preferences, (card, key) => {
      let tab = _.find(tabs, (t) => {
        return t.key === card.tabGroup;
      })
      if (!tab) {
        tab = ({key: card.tabGroup, cards: []});
        tab.cards.push(card)
        tabs.push(tab);
      } else {
        tab.cards.push(card)
      }
    })

    return tabs;
  }

  getPreferencesByGroup(preferences): any {
    let allPreferences = {};

    _.forEach(preferences, (element) => {
      let parentGroupName = _.get(element, "parentGroupName"),
        parentGroup = _.get(element, "parentGroup"),
        groupName = _.get(element, 'groupName'),
        group = _.get(element, 'group'),
        tabGroup = _.get(element, 'tabGroup'),
        key = _.get(element, 'key');

      const tab = _.camelCase(parentGroup);
      const card = _.camelCase(group);

      if (_.isUndefined(allPreferences[tab])) {
        _.set(allPreferences, tab, {})
      }

      if (_.isUndefined(allPreferences[tab][card])) {
        _.set(allPreferences[tab], card, {
          name: groupName,
          tabGroup: tabGroup,
          list: []
        })
      }

      allPreferences[tab][card].list.push(element);
    });
    return allPreferences;
  }

  getGlobalsByGroup(globals) {
    let allGlobals = {};

    _.forEach(globals, (global) => {
      const groupName = _.get(global, 'groupName'),
        group = _.get(global, 'group'),
        key = _.get(global, 'key');

      const card = _.camelCase(group);

      if (_.isUndefined(allGlobals[card])) {
        _.set(allGlobals, card, {
          name: groupName,
          list: []
        })
      }

      allGlobals[card].list.push(global);
    });

    return allGlobals;
  }

}

angular
  .module('bringoz.admin.commons')
  .service('configurationCommons', ConfigurationCommons);
